import { FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app';
import {
  AppCheck,
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from 'firebase/app-check';

export const firebaseConfig = {
  apiKey: 'AIzaSyAy5Z7sP8CK5pW7o-Ml4pcaHHsmyFc1XXc',
  authDomain: 'ploggit-ee778.firebaseapp.com',
  projectId: 'ploggit-ee778',
  storageBucket: 'ploggit-ee778.appspot.com',
  messagingSenderId: '265326741817',
  appId: '1:265326741817:web:c1f56306cf3c95a2f4c0e8',
  measurementId: 'G-ZWK7TQQTEX',
};

export const recaptchaEnterpriseSiteKey =
  '6LfHvqQtAAAAAKvg4sXCbtTD9TPWqEpwblZmvP_3';

let appCheckInstance: AppCheck | null = null;

export function getOrInitFirebaseApp(): FirebaseApp {
  return getApps().length ? getApp() : initializeApp(firebaseConfig);
}

export function shouldEnableAppCheck(): boolean {
  return typeof window !== 'undefined' && firebaseConfig.projectId === 'ploggit-ee778';
}

export function initAppCheck(app: FirebaseApp = getOrInitFirebaseApp()): AppCheck | null {
  if (appCheckInstance) {
    return appCheckInstance;
  }

  if (!shouldEnableAppCheck()) {
    return null;
  }

  appCheckInstance = initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(recaptchaEnterpriseSiteKey),
    isTokenAutoRefreshEnabled: true,
  });

  return appCheckInstance;
}
